import { render, staticRenderFns } from "./CBlockBlogNews.vue?vue&type=template&id=f2156956&"
import script from "./CBlockBlogNews.vue?vue&type=script&lang=ts&"
export * from "./CBlockBlogNews.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports